module.exports = __webpack_public_path__ + "img/unionpay.2084129d.png";